import { PredictionLabelType } from '@modules/feedback/types';
import { FormatQuoteRounded, NumbersRounded } from '@mui/icons-material';
import { FeedbackLabel } from 'v2/core/entities/feedback';
import { getLabelTypeFromPredictionType } from './getLabelTypeFromPredictionType';
import { SvgIconProps } from '@mui/material';

export const getFeedbackLabelIcon = (
  label: FeedbackLabel,
  fontSize: SvgIconProps['fontSize'] = 'small',
) => {
  switch (label.type) {
    case getLabelTypeFromPredictionType(PredictionLabelType.Entity):
      return <NumbersRounded color="primary" fontSize={fontSize} />;
    case getLabelTypeFromPredictionType(PredictionLabelType.Reason):
      return <FormatQuoteRounded color="primary" fontSize={fontSize} />;
    default:
      return null;
  }
};
